// src/components/common/LoadingOverlay.jsx
import React from 'react';
import styled from '@emotion/styled';
import { Loader } from 'lucide-react';

const OverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
`;

const Spinner = styled(Loader)`
  width: 48px;
  height: 48px;
  color: ${({ theme }) => theme.colors.green};
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const LoadingOverlay = () => {
  return (
    <OverlayContainer>
      <Spinner />
    </OverlayContainer>
  );
};

export default LoadingOverlay;
